import { gql } from '@apollo/client';

export const RescheduleAppointment = gql`
  mutation($record: PractitionerRescheduleAppointmentInput!) {
    schedule {
      rescheduleAppointment(record: $record) {
        ok
        error {
          code
          message
        }
        resultId
        result {
          id
          title
          startDate
          endDate
          reservationModeId
          roomId
        }
      }
    }
  }
`;
